// Centralized mapping from snake_case database values to human-readable labels
// Used in directory filters, cards, and profile pages

export const specialtyLabels: Record<string, string> = {
  // Geriatric Care Manager
  care_coordination: 'Care Coordination',
  dementia_care: 'Dementia Care',
  chronic_disease: 'Chronic Disease Management',
  family_mediation: 'Family Mediation',
  discharge_planning: 'Discharge Planning',
  
  // OT/PT
  falls_prevention: 'Falls Prevention',
  home_safety: 'Home Safety Assessment',
  mobility_training: 'Mobility Training',
  adaptive_equipment: 'Adaptive Equipment',
  balance_strength: 'Balance & Strength',
  adl: 'Activities of Daily Living',
  
  // CAPS Specialist
  bathroom_mods: 'Bathroom Modifications',
  kitchen_accessibility: 'Kitchen Accessibility',
  stairway_safety: 'Stairway Safety',
  lighting_visibility: 'Lighting & Visibility',
  universal_design: 'Universal Design',
  smart_home: 'Smart Home Integration',
  
  // Elder Law Attorney
  estate_planning: 'Estate Planning',
  medicaid_planning: 'Medicaid Planning',
  guardianship: 'Guardianship',
  ltc_planning: 'Long-Term Care Planning',
  veterans_benefits: 'Veterans Benefits',
  
  // Financial Advisor
  retirement_planning: 'Retirement Planning',
  ltc_insurance: 'Long-Term Care Insurance',
  medicare_planning: 'Medicare Planning',
  estate_preservation: 'Estate Preservation',
  tax_strategy: 'Tax Strategy',
  
  // Caregiver Agency
  personal_care: 'Personal Care',
  companionship: 'Companionship',
  medication_reminders: 'Medication Reminders',
  meal_prep: 'Meal Preparation',
  transportation: 'Transportation',
  respite_care: 'Respite Care',
  
  // Social Worker
  resource_navigation: 'Resource Navigation',
  crisis_intervention: 'Crisis Intervention',
  family_counseling: 'Family Counseling',
  benefits_enrollment: 'Benefits Enrollment',
  care_transitions: 'Care Transitions',
  
  // Home Modification Contractor
  accessibility_ramps: 'Accessibility Ramps',
  grab_bars: 'Grab Bars & Rails',
  walk_in_tubs: 'Walk-in Tubs',
  widening_doorways: 'Widening Doorways',
  flooring_safety: 'Flooring Safety',
  threshold_removal: 'Threshold Removal',
  
  // Clinician
  wound_care: 'Wound Care',
  medication_management: 'Medication Management',
  health_monitoring: 'Health Monitoring',
  palliative_care: 'Palliative Care',
  telehealth: 'Telehealth',
  
  // Other Senior Services
  wellness_programs: 'Wellness Programs',
  nutrition_counseling: 'Nutrition Counseling',
  senior_fitness: 'Senior Fitness',
  tech_assistance: 'Technology Assistance',
};

/**
 * Get the human-readable label for a specialty value.
 * Falls back to formatting the value if not found in the mapping.
 */
export function getSpecialtyLabel(value: string): string {
  if (specialtyLabels[value]) {
    return specialtyLabels[value];
  }
  
  // If it's already human-readable (contains spaces or capital letters), return as-is
  if (value.includes(' ') || /[A-Z]/.test(value)) {
    return value;
  }
  
  // Format snake_case to Title Case as fallback
  return value
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}
